var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000295774 2.64628C0.00278676 3.28139 0.271343 3.88807 0.743979 4.32629L10.3399 13.333C11.2727 14.2223 12.7657 14.2223 13.6985 13.333L23.2944 3.99962C23.9029 3.40775 24.1406 2.54507 23.9179 1.73656C23.6951 0.928047 23.0458 0.296526 22.2146 0.0798855C21.3833 -0.136755 20.4964 0.0943985 19.8879 0.686271L11.9952 8.38631L4.07857 0.966272C3.14287 0.0615795 1.63169 0.0615794 0.696001 0.966272C0.24099 1.41232 -0.00983033 2.01801 0.000295774 2.64628Z",
    fill: "#0D41E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqArrow);
export default __webpack_public_path__ + "static/media/faqArrow.bbd3c9bb0832eff879f1fff5dbb9b391.svg";
export { ForwardRef as ReactComponent };